/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	CreateDirectiveRequest,
	Directive,
	DirectiveListResponse,
	PraetoidError,
	SyncDirectivesParams,
	UpdateDirectiveRequest
} from '../models';

/**
 * Returns all directives for the organization
 * @summary List directives
 */
export const listDirectives = () => {
	return customInstance<DirectiveListResponse>({ url: `/directives`, method: 'GET' });
};

export const getListDirectivesQueryKey = () => {
	return ['directives'] as const;
};

export const getListDirectivesQueryOptions = <
	TData = Awaited<ReturnType<typeof listDirectives>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDirectives>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListDirectivesQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listDirectives>>> = () => listDirectives();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listDirectives>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDirectivesQueryResult = NonNullable<Awaited<ReturnType<typeof listDirectives>>>;
export type ListDirectivesQueryError = ErrorType<PraetoidError>;

export function useListDirectives<
	TData = Awaited<ReturnType<typeof listDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDirectives>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDirectives>>,
					TError,
					Awaited<ReturnType<typeof listDirectives>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDirectives<
	TData = Awaited<ReturnType<typeof listDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDirectives>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDirectives>>,
					TError,
					Awaited<ReturnType<typeof listDirectives>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDirectives<
	TData = Awaited<ReturnType<typeof listDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDirectives>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List directives
 */

export function useListDirectives<
	TData = Awaited<ReturnType<typeof listDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDirectives>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListDirectivesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new directive for the organization
 * @summary Create a directive
 */
export const createDirective = (createDirectiveRequest: CreateDirectiveRequest) => {
	return customInstance<Directive>({
		url: `/directives`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: createDirectiveRequest
	});
};

export const getCreateDirectiveMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createDirective>>,
		TError,
		{ data: CreateDirectiveRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createDirective>>,
	TError,
	{ data: CreateDirectiveRequest },
	TContext
> => {
	const mutationKey = ['createDirective'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createDirective>>,
		{ data: CreateDirectiveRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createDirective(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateDirectiveMutationResult = NonNullable<
	Awaited<ReturnType<typeof createDirective>>
>;
export type CreateDirectiveMutationBody = CreateDirectiveRequest;
export type CreateDirectiveMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a directive
 */
export const useCreateDirective = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createDirective>>,
			TError,
			{ data: CreateDirectiveRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createDirective>>,
	TError,
	{ data: CreateDirectiveRequest },
	TContext
> => {
	return useMutation(getCreateDirectiveMutationOptions(options), queryClient);
};
/**
 * Deletes a directive. Built-in directives cannot be deleted.
 * @summary Delete a directive
 */
export const deleteDirective = (id: string) => {
	return customInstance<void>({ url: `/directives/${id}`, method: 'DELETE' });
};

export const getDeleteDirectiveMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteDirective>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteDirective>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['deleteDirective'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteDirective>>,
		{ id: string }
	> = (props) => {
		const { id } = props ?? {};

		return deleteDirective(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteDirectiveMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteDirective>>
>;

export type DeleteDirectiveMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete a directive
 */
export const useDeleteDirective = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteDirective>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deleteDirective>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getDeleteDirectiveMutationOptions(options), queryClient);
};
/**
 * Returns a single directive by ID
 * @summary Get a directive
 */
export const getDirective = (id: string) => {
	return customInstance<Directive>({ url: `/directives/${id}`, method: 'GET' });
};

export const getGetDirectiveQueryKey = (id: string) => {
	return ['directives', id] as const;
};

export const getGetDirectiveQueryOptions = <
	TData = Awaited<ReturnType<typeof getDirective>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirective>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDirectiveQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirective>>> = () => getDirective(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDirective>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDirectiveQueryResult = NonNullable<Awaited<ReturnType<typeof getDirective>>>;
export type GetDirectiveQueryError = ErrorType<PraetoidError>;

export function useGetDirective<
	TData = Awaited<ReturnType<typeof getDirective>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirective>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDirective>>,
					TError,
					Awaited<ReturnType<typeof getDirective>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDirective<
	TData = Awaited<ReturnType<typeof getDirective>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirective>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDirective>>,
					TError,
					Awaited<ReturnType<typeof getDirective>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDirective<
	TData = Awaited<ReturnType<typeof getDirective>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirective>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a directive
 */

export function useGetDirective<
	TData = Awaited<ReturnType<typeof getDirective>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirective>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetDirectiveQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates a directive's name and description
 * @summary Update a directive
 */
export const updateDirective = (id: string, updateDirectiveRequest: UpdateDirectiveRequest) => {
	return customInstance<Directive>({
		url: `/directives/${id}`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: updateDirectiveRequest
	});
};

export const getUpdateDirectiveMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateDirective>>,
		TError,
		{ id: string; data: UpdateDirectiveRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateDirective>>,
	TError,
	{ id: string; data: UpdateDirectiveRequest },
	TContext
> => {
	const mutationKey = ['updateDirective'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateDirective>>,
		{ id: string; data: UpdateDirectiveRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateDirective(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateDirectiveMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateDirective>>
>;
export type UpdateDirectiveMutationBody = UpdateDirectiveRequest;
export type UpdateDirectiveMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update a directive
 */
export const useUpdateDirective = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateDirective>>,
			TError,
			{ id: string; data: UpdateDirectiveRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updateDirective>>,
	TError,
	{ id: string; data: UpdateDirectiveRequest },
	TContext
> => {
	return useMutation(getUpdateDirectiveMutationOptions(options), queryClient);
};
/**
 * Returns all directives
 * @summary Sync directives
 */
export const syncDirectives = (params?: SyncDirectivesParams) => {
	return customInstance<DirectiveListResponse>({ url: `/sync/directives`, method: 'GET', params });
};

export const getSyncDirectivesQueryKey = (params?: SyncDirectivesParams) => {
	return ['sync', 'directives', ...(params ? [params] : [])] as const;
};

export const getSyncDirectivesQueryOptions = <
	TData = Awaited<ReturnType<typeof syncDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	params?: SyncDirectivesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof syncDirectives>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getSyncDirectivesQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof syncDirectives>>> = () =>
		syncDirectives(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof syncDirectives>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SyncDirectivesQueryResult = NonNullable<Awaited<ReturnType<typeof syncDirectives>>>;
export type SyncDirectivesQueryError = ErrorType<PraetoidError>;

export function useSyncDirectives<
	TData = Awaited<ReturnType<typeof syncDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | SyncDirectivesParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof syncDirectives>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof syncDirectives>>,
					TError,
					Awaited<ReturnType<typeof syncDirectives>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSyncDirectives<
	TData = Awaited<ReturnType<typeof syncDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	params?: SyncDirectivesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof syncDirectives>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof syncDirectives>>,
					TError,
					Awaited<ReturnType<typeof syncDirectives>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSyncDirectives<
	TData = Awaited<ReturnType<typeof syncDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	params?: SyncDirectivesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof syncDirectives>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sync directives
 */

export function useSyncDirectives<
	TData = Awaited<ReturnType<typeof syncDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	params?: SyncDirectivesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof syncDirectives>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getSyncDirectivesQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
